// docuemnt ready vanilla js
document.addEventListener('DOMContentLoaded', function() {
    // interval .5 seconds
    
    
    const cv2interval = setInterval(function() {
        // check if the consent code is present
        const consentLayer = {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
        };
        const originalConsentLayer = {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
        };
               

        if( window.Shopify !== 'undefined' ){
            // set customerPrivacy object 
            var customerPrivacy = window.Shopify.customerPrivacy;
            var currentConsent = customerPrivacy.currentVisitorConsent();
            if( typeof currentConsent.marketing !== 'undefined' ){
                if( currentConsent.marketing === 'yes' ){
                    consentLayer.ad_storage = 'granted';
                    consentLayer.ad_user_data = 'granted';
                    consentLayer.ad_personalization = 'granted';
                }
            }
            if( typeof currentConsent.analytics !== 'undefined' ){
                if( currentConsent.analytics === 'yes' ){
                    consentLayer.analytics_storage = 'granted';
                }
                
            }
        }
        if ( typeof window.currentConsent !== 'undefined' ) {
            var oldConsent = window.currentConsent;
            if ( oldConsent.ad_storage === consentLayer.ad_storage && oldConsent.ad_user_data === consentLayer.ad_user_data && oldConsent.ad_personalization === consentLayer.ad_personalization && oldConsent.analytics_storage === consentLayer.analytics_storage ) {
                return;
            }
            gtag('consent', 'update', consentLayer );
            window.currentConsent = consentLayer;
            window.localStorage.setItem('currentConsent', JSON.stringify(consentLayer) );
         }else{
            gtag('consent', 'default', originalConsentLayer );
            gtag('consent', 'update', consentLayer );
            window.currentConsent = consentLayer;
            window.localStorage.setItem('currentConsent', JSON.stringify(consentLayer) );
        }
    }, 500);
    // add interval to window object
    window.cv2interval = cv2interval;
});